import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
    groupItemWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        paddingBottom: 10,
        cursor: 'pointer'
    },
    text: {
        color: theme.textSecondary,
        fontSize: 13,
        fontWeight: 'bold'
    }
}))
